const rowChecked = "flex items-center justify-between px-4 py-3 text-sm border-b border-border/40 last:border-b-0 transition-colors duration-150";

const rowUnchecked =
  "flex items-center justify-between px-4 py-3 text-sm border-b border-border/40 last:border-b-0 opacity-60 hover:bg-muted/50 transition-colors duration-150";

const checkboxBtnChecked = "h-4 w-4 rounded border-2 flex items-center justify-center transition-colors shrink-0 bg-primary border-primary";

const checkboxBtnUnchecked =
  "h-4 w-4 rounded border-2 flex items-center justify-center transition-colors shrink-0 border-muted-foreground/40 bg-transparent hover:border-muted-foreground/60";

const innerDiv = "flex-1 min-w-0 ml-3";

const nameGroup = "flex items-center gap-2 min-w-0";

const icon = "h-3.5 w-3.5 text-muted-foreground shrink-0";

const nameText = "font-medium truncate";

export { rowChecked, rowUnchecked, checkboxBtnChecked, checkboxBtnUnchecked, innerDiv, nameGroup, icon, nameText };
